'use client';

import { useEffect } from 'react';

export default function ServiceWorkerRegister() {
    useEffect(() => {
        if (typeof window === 'undefined') return;
        if (!('serviceWorker' in navigator)) return;

        const register = async () => {
            try {
                await navigator.serviceWorker.register('/sw.js');
            } catch (error) {
                console.error('Service worker registration failed:', error);
            }
        };

        if (document.readyState === 'complete') {
            void register();
            return;
        }

        window.addEventListener('load', register);
        return () => window.removeEventListener('load', register);
    }, []);

    return null;
}
